__turbopack_context__.v({
  "apiDocsLink": "footer-module-scss-module__f_SUrW__apiDocsLink",
  "column": "footer-module-scss-module__f_SUrW__column",
  "columnTitle": "footer-module-scss-module__f_SUrW__columnTitle",
  "content": "footer-module-scss-module__f_SUrW__content",
  "contentWidth": "footer-module-scss-module__f_SUrW__contentWidth",
  "footerGroupDivider": "footer-module-scss-module__f_SUrW__footerGroupDivider",
  "linksContainer": "footer-module-scss-module__f_SUrW__linksContainer",
  "logoPosition": "footer-module-scss-module__f_SUrW__logoPosition",
  "navigation": "footer-module-scss-module__f_SUrW__navigation",
  "panel": "footer-module-scss-module__f_SUrW__panel",
  "panelArrow": "footer-module-scss-module__f_SUrW__panelArrow",
  "supportEmailLink": "footer-module-scss-module__f_SUrW__supportEmailLink",
});
